// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2jtgE","additionalInfo":"AgreementModal_additionalInfo__2XUMH"};